import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=06d96aca&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d96aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d96aca')) {
      api.createRecord('06d96aca', component.options)
    } else {
      api.reload('06d96aca', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=06d96aca&scoped=true", function () {
      api.rerender('06d96aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/Header.vue"
export default component.exports